import React, { useEffect, useRef, useState } from "react";
import "./Government.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Government = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Digital Governance Platforms",
      description:
        "Comprehensive digital systems for citizen services and government operations",
      whatsappMessage:
        "Hello, I'm interested in Digital Governance Platforms consultation.",
    },
    {
      id: 2,
      title: "Public Service Automation",
      description:
        "AI-powered solutions for streamlining and automating government service delivery",
      whatsappMessage:
        "Hello, I'm interested in Public Service Automation consultation.",
    },
    {
      id: 3,
      title: "Data Analytics for Policy Making",
      description:
        "Data-driven insights for policy evaluation, implementation, and decision making",
      whatsappMessage:
        "Hello, I'm interested in Data Analytics for Policy Making consultation.",
    },
    {
      id: 4,
      title: "Citizen Portal Solutions",
      description:
        "Digital platforms for citizen engagement and service access",
      whatsappMessage:
        "Hello, I'm interested in Citizen Portal Solutions consultation.",
    },
    {
      id: 5,
      title: "Government CRM Systems",
      description:
        "Citizen relationship management tailored for government agencies",
      whatsappMessage:
        "Hello, I'm interested in Government CRM Systems consultation.",
    },
    {
      id: 6,
      title: "Security & Surveillance Technology",
      description:
        "AI and machine learning solutions for public safety and security",
      whatsappMessage:
        "Hello, I'm interested in Security & Surveillance Technology consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="government-sector-page">
      <Helmet>
        <title>
          Government Sector Technology Solutions | Digital Transformation for
          Public Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive government technology solutions including digital governance platforms, public service automation, policy analytics, and citizen portal solutions."
        />
        <meta
          name="keywords"
          content="government technology, govtech, digital governance, public service automation, policy analytics, government CRM, security technology, government solutions, government innovation, government apps, public sector data, government SaaS, public sector management, digital transformation government"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="government-sector-hero">
        <div className="government-sector-hero-content">
          <h1 className="government-sector-hero-title">
            Transforming{" "}
            <span className="government-sector-highlight">
              Public Service Delivery
            </span>
          </h1>
          <p className="government-sector-hero-description">
            We deliver cutting-edge government technology solutions that
            streamline operations, enhance citizen experience, and drive
            efficiency. From digital governance to service automation and
            data-driven policy making.
          </p>
          <div className="government-sector-hero-buttons">
            <a href="/contact-us">
              <button className="government-sector-btn government-sector-btn-primary">
                Get Started
              </button>
            </a>
            <button className="government-sector-btn government-sector-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="government-sector-hero-visual">
          <div className="government-sector-animated-building">
            <div className="government-sector-building-core"></div>
            <div className="government-sector-windows-grid"></div>
            <div className="government-sector-flag-pole"></div>
          </div>
          <div className="government-sector-orb government-sector-orb-1"></div>
          <div className="government-sector-orb government-sector-orb-2"></div>
          <div className="government-sector-orb government-sector-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="government-sector-services">
        <div className="government-sector-services-header">
          <h2 className="government-sector-section-title">
            Our Government Technology Solutions
          </h2>
          <p className="government-sector-section-subtitle">
            Innovative government technology services designed to modernize
            public services, enhance operational efficiency, and improve citizen
            satisfaction.
          </p>
        </div>

        <div className="government-sector-services-grid">
          {/* Digital Governance Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-governance"></div>
            </div>
            <h3>Digital Governance Platforms</h3>
            <p>
              Comprehensive digital systems for managing government operations,
              services, and citizen data.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>E-Governance Solutions</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Service Delivery</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Document Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Efficiency Gain</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.7%</div>
                <div className="stat-label">Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Public Service Automation Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-automation"></div>
            </div>
            <h3>Public Service Automation</h3>
            <p>
              AI-powered solutions for streamlining and automating government
              service processes.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Documentation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Workflow Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Status Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">65%</div>
                <div className="stat-label">Faster Processing</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">88%</div>
                <div className="stat-label">Citizen Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Policy Analytics Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-analytics"></div>
            </div>
            <h3>Policy Analytics Solutions</h3>
            <p>
              Data-driven insights for policy evaluation, implementation, and
              decision making.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Modeling</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Data Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Impact Assessment</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Policy Simulation</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Better Decisions</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">55%</div>
                <div className="stat-label">Faster Analysis</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Citizen Portal Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-portal"></div>
            </div>
            <h3>Citizen Portal Solutions</h3>
            <p>
              Digital platforms for citizen self-service, information access,
              and government interaction.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Service Access</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Application Submission</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Payment Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Information Access</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Service Cost Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">92%</div>
                <div className="stat-label">Citizen Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Government CRM Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-crm"></div>
            </div>
            <h3>Government CRM Systems</h3>
            <p>
              Citizen relationship management tailored for government agencies
              and departments.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Case Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Service Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Communication Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Analytics</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Efficiency Increase</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">80%</div>
                <div className="stat-label">Staff Productivity</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Security Technology Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-security"></div>
            </div>
            <h3>Security & Surveillance Technology</h3>
            <p>
              AI and machine learning solutions for public safety, security, and
              threat detection.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Threat Recognition</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Anomaly Detection</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Alerts</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">75%</div>
                <div className="stat-label">Threat Detection Rate</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Response Time Improvement</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Smart City Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-smartcity"></div>
            </div>
            <h3>Smart City Solutions</h3>
            <p>
              Integrated technology solutions for urban management and smart
              city development.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>IoT Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Urban Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Resource Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Infrastructure Monitoring</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Operational Efficiency</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Resource Optimization</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Compliance Card */}
          <div className="government-sector-service-card">
            <div className="government-sector-service-icon">
              <div className="government-sector-icon government-sector-icon-compliance"></div>
            </div>
            <h3>Regulatory Compliance Tools</h3>
            <p>
              Solutions to ensure compliance with government regulations and
              reporting requirements.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Reporting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Audit Trails</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Regulation Updates</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Monitoring</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">55%</div>
                <div className="stat-label">Time Saved</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Compliance Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="government-sector-services-cta">
          <h3>Ready to transform your government services?</h3>
          <p>
            Schedule a free consultation with our government technology experts
            to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="government-sector-consultation-container">
              <button
                className="government-sector-primary-btn government-sector-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="government-sector-modal-overlay">
                  <div className="government-sector-modal-content">
                    <button
                      className="government-sector-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="government-sector-modal-title">
                      Government Technology Consultation
                    </h2>
                    <p className="government-sector-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="government-sector-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`government-sector-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="government-sector-option-title">
                            {option.title}
                          </h3>
                          <p className="government-sector-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`government-sector-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="government-sector-btn government-sector-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="government-sector-stats">
        <div className="government-sector-stats-container">
          <div className="government-sector-stat">
            <h3 className="government-sector-stat-number" data-count="150">
              15
            </h3>
            <p className="government-sector-stat-label">Government Projects</p>
          </div>
          <div className="government-sector-stat">
            <h3 className="government-sector-stat-number" data-count="95">
              10
            </h3>
            <p className="government-sector-stat-label">Client Satisfaction</p>
          </div>
          <div className="government-sector-stat">
            <h3 className="government-sector-stat-number" data-count="12">
              11
            </h3>
            <p className="government-sector-stat-label">Years Experience</p>
          </div>
          <div className="government-sector-stat">
            <h3 className="government-sector-stat-number" data-count="25">
              1
            </h3>
            <p className="government-sector-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="government-sector-cta">
        <div className="government-sector-cta-content">
          <h2>Ready to Transform Your Government Services?</h2>
          <p>
            Contact us today to discuss how our government technology expertise
            can help your organization innovate and improve service delivery.
          </p>
          <a href="/contact-us">
            <button className="government-sector-btn government-sector-btn-primary government-sector-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Government;
